import { ENTITLEMENT_SLUGS } from 'constants/entitlements/entitlements';
import {
  EntitlementSlug,
  StoreEntitlementRow,
  StoreEntitlementState,
  StoreSummary,
} from 'types/entitlements/entitlements';

const ALL_SLUGS: EntitlementSlug[] = Object.values(ENTITLEMENT_SLUGS);

/**
 * One row per store the entitlements read describes, named from the business's store list.
 *
 * The read is the source of truth for which stores appear — it includes unprovisioned stores and
 * leaves out residential ones — so a store missing from the name list still gets a row rather than
 * disappearing from the screen.
 */
export function buildStoreEntitlementRows(
  stores: StoreSummary[],
  entitlements: StoreEntitlementState[],
): StoreEntitlementRow[] {
  const namesById = new Map(stores.map(({ id, name }) => [id, name]));

  return entitlements
    .map(({ storeId, slugs, source }) => ({
      id: storeId,
      name: namesById.get(storeId) ?? `Store #${storeId}`,
      slugs: ALL_SLUGS.filter((slug) => slugs[slug]),
      source,
    }))
    .sort((left, right) => left.name.localeCompare(right.name));
}

/** Slugs held by at least one of the given rows — the only ones a revocation can change. */
export function getHeldSlugs(rows: StoreEntitlementRow[]): EntitlementSlug[] {
  return ALL_SLUGS.filter((slug) => rows.some((row) => row.slugs.includes(slug)));
}
